import { useEffect, useState } from "react";
import Tabs from "../../../../Customer/Component/Tabs";
import { formatDate, formatTime, formatWord } from "../../../../Utils/utils";
import {
  useAddPatientCarePackagesMutation,
  useUpdateCarePackageStatusMutation,
} from "../../../../../../Service/PatientList";
import BackdropLoader from "../../../../../../Component/DigitalMarketing/BackDropLoader";
import ModalComponent from "../../../../Appoinment/component/ModalComponent";
import AddCarePackages from "./AddCarePackages";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const CarePackages = ({ CarePackageData, refetchCarePackage }) => {
  const [active, setActive] = useState(1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState({
    show: false,
    id: "",
    type: "",
  });
  const [updateStatus, { isLoading: updateLoading, isSuccess }] =
    useUpdateCarePackageStatusMutation();

  const values = [
    { id: 1, name: "Active Care Packages" },
    { id: 2, name: "Previous Care Packages" },
  ];
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;

  const activePackages = CarePackageData?.data?.activePackages || [];
  const previousPackages = CarePackageData?.data?.previousPackages || [];
  const location = useLocation();

  const { consultantId } = location.state || {};

  const handleShowEdit = (Id: any, Type: string) => {
    setShowEdit((prev) => ({
      ...prev,
      show: true,
      id: Id,
      type: Type,
    }));
  };

  const handleSubmit = () => {
    const payload = {
      carePackageStatus: showEdit.type,
    };
    updateStatus({ id: showEdit.id, ...payload });
  };

  useEffect(() => {
    if (isSuccess) {
      setShowEdit({
        show: false,
        id: "",
        type: "",
      });
      refetchCarePackage();
    }
  }, [isSuccess]);
  return (
    <div>
      <BackdropLoader loader={updateLoading} />
      {(roleName === "branch" || roleName === "receptionist") &&
        consultantId && (
          <div className="row justify-content-end">
            <button
              className="btn btn-violet col-3"
              onClick={() => setShowAdd(true)}
            >
              Assign Packages
            </button>
          </div>
        )}

      <div>
        <Tabs tablist={values} active={active} setActive={setActive} />
      </div>

      {active === 1 && (
        <>
          {activePackages.length > 0 ? (
            activePackages.map((c: any) => (
              <div className="card p-3 mt-2" key={c?.id}>
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center mt-2"
                      style={{
                        backgroundColor: "#D8D8D8",
                        width: "44px",
                        height: "44px",
                        borderRadius: "50%",
                      }}
                    >
                      <span className="material-symbols-outlined">
                        package_2
                      </span>
                    </div>
                    <div>
                      <div className="d-flex flex-column">
                        <span className="f-21 fw-500">
                          {formatWord(c?.packageName)}
                        </span>
                        <span
                          className="f-20 fw-600"
                          style={{ color: "#007CCF" }}
                        >
                          {c?.price && `₹ ${c?.price}`}
                        </span>
                      </div>
                      <div className="d-flex flex-column mt-2">
                        <span
                          className="f-14 fw-400"
                          style={{ color: "#6B737F" }}
                        >
                          includes
                        </span>
                        <span className="fw-500 f-16">
                          {formatWord(c?.CarePackagesServices?.procedureName)}
                        </span>
                      </div>
                      <div>
                        <span
                          className="f-12 fw-600"
                          style={{
                            backgroundColor: "#EFF8FF",
                            color: "#3F7ADD",
                            padding: "6px",
                            borderRadius: "14px",
                          }}
                        >
                          Expires in {c?.expiryDays}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="d-flex justify-content-center mb-2">
                      <button
                        onClick={() => handleShowEdit(c?.id, "Completed")}
                        className="edit-event"
                      >
                        <span className="material-symbols-outlined f-18 fw-400">
                          edit
                        </span>
                      </button>
                    </div>
                    <span style={{ color: "#2EA286" }}>
                      <u>Completed</u>
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center mt-5 fw-bold">
              No Active Care Packages Found !
            </div>
          )}
        </>
      )}

      {active === 2 && (
        <>
          {previousPackages.length > 0 ? (
            previousPackages.map((c: any) => (
              <div className="card p-3 mt-2" key={c?.id}>
                <div className="d-flex gap-3">
                  <div
                    className="d-flex align-items-center justify-content-center mt-2"
                    style={{
                      backgroundColor: "#0060FF",
                      width: "44px",
                      height: "44px",
                      borderRadius: "50%",
                    }}
                  >
                    <span className="material-symbols-outlined text-white">
                      package_2
                    </span>
                  </div>
                  <div>
                    <div className="d-flex flex-column">
                      <span className="f-18 fw-400">
                        {formatDate(c?.updatedAt)}
                      </span>
                      <span className="f-21 fw-500">
                        {formatWord(c?.packageName)} with{" "}
                        <span style={{ color: "#007CCF" }}>
                          {formatWord(c?.CarePackagesServices?.procedureName)}
                        </span>
                      </span>
                    </div>
                    <div className="d-flex align-items-center">
                      <span
                        className="material-symbols-outlined"
                        style={{ color: "#696969" }}
                      >
                        schedule
                      </span>
                      <span
                        style={{ color: "#696969" }}
                        className="ms-2 f-18 fw-400"
                      >
                        Updated Time
                      </span>
                      <span className="f-18 fw-600 ms-2">
                        {formatTime(c?.updatedAt)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center mt-5 fw-bold">
              No Previous Care Packages Found !
            </div>
          )}
        </>
      )}
      <ModalComponent
        title="Assign Packages"
        show={showAdd}
        body={
          <AddCarePackages
            setShowAdd={setShowAdd}
            refetchCarePackage={refetchCarePackage}
          />
        }
        onClose={() => setShowAdd(false)}
      />
      <ModalComponent
        title="Update Status"
        show={showEdit.show}
        onSubmit={handleSubmit}
        body={
          <>
            {`Are you sure you want to complete `}
            <div className="mt-3 d-flex gap-3 justify-content-end">
              <button
                className="btn border text-secondary"
                onClick={() => setShowEdit({ show: false, id: "", type: "" })}
              >
                No
              </button>
              <button className="btn btn-violet" onClick={() => handleSubmit()}>
                Yes
              </button>
            </div>
          </>
        }
        onClose={() => setShowEdit({ show: false, id: "", type: "" })}
      />
    </div>
  );
};

export default CarePackages;
